import { createSelector } from 'reselect';
import { ROUTE_USER_PROFILE_PAGE } from '../../routeActions';
import { selectLocation } from '../../location/selectors';

export const selectCurrentProfileUserProfileName = createSelector(
  selectLocation,
  (location) => {
    switch (location.get('type')) {
      case ROUTE_USER_PROFILE_PAGE: {
        return location.getIn(['params', 'profileName']);
      }
      default: {
        return null; // A routing action for another page
      }
    }
  }
);
